import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const facilityEvaInfoRepository = RepositoryFactory.get("facilityEvaInfo");
const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setFacilityEvaInfo(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadFacilityEvaInfo(context, payload) {
    const list = await facilityEvaInfoRepository.list(
      payload.screenId,
      payload.disasterNo
    );
    if (list.status < 300) {
      context.commit("setFacilityEvaInfo", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
